/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { AuditReportDto } from '../../models/audit-report-dto';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

export interface GetAfterSalesTabData$Params {}

export function getAfterSalesTabData(
  http: HttpClient,
  rootUrl: string,
  params?: GetAfterSalesTabData$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<Array<AuditReportDto>>> {
  const rb = new RequestBuilder(rootUrl, getAfterSalesTabData.PATH, 'get');
  if (params) {
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AuditReportDto>>;
    }),
  );
}

getAfterSalesTabData.PATH = '/service/v1/afterSales';
